export const environment = process.env.REACT_APP_ENV
export const version = process.env.REACT_APP_VERSION
export const REACT_APP_LANGUAGE_CHANGE_ENABLE = process.env.REACT_APP_LANGUAGE_CHANGE_ENABLE